<template>
  <el-dialog
    title="账号迁移"
    :close-on-click-modal="false"
    :visible.sync="visible"
    width="650px"
    append-to-body
    @close="close">
    <el-form label-width="85px" :model="form" ref="form">
      <el-form-item
        label="迁移账号:"
        prop="target"
        :rules="[{ required: true, message: '请选择迁移账号', trigger: 'blur' }]"
      >
        <el-select
          style="width: 70%"
          @change="handleSelect"
          v-model="form.target"
          filterable
          remote
          clearable
          reserve-keyword
          placeholder="请输入用户ID或用户手机号码"
          :remote-method="handleSearchUser"
          :loading="loading">
          <template #prefix>
            <span style="padding-left: 5px;">
              <i class="el-icon-search"/>
            </span>
          </template>
          <el-option
            v-for="item in users"
            :key="item.id"
            :label="item.id + ' / ' + item.telphone"
            :value="item.id"
            :disabled="item.id === form.source">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-card class="box-card" v-if="selected">
          <div class="wrapper">
            <div class="block">
              <el-avatar shape="square" :size="60" :src="selected.avatarUrl" @error="true">
                <img src="https://cube.elemecdn.com/9/c2/f0ee8a3c7c9638a54940382568c9dpng.png"/>
              </el-avatar>
            </div>
            <div>
              <div>{{ selected.nickName }}</div>
              <div>{{ selected.id + ' / ' + selected.telphone }}</div>
            </div>
          </div>
        </el-card>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false" size="small">取消</el-button>
        <el-button type="primary" size="small" @click="handleSave">确定</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  props: {},
  data() {
    return {
      visible: false,
      loading: false,
      form: {
        source: "",
        target: "",
      },
      selected: null,
      users: [],
      squareUrl: "",
    }
  },
  methods: {
    show(userId) {
      this.visible = true
      this.form.source = userId
    },
    close() {
      this.visible = false
      this.$refs['form'].resetFields()
      this.selected = null
    },
    handleSearchUser(query) {
      if (query !== '') {
        this.$http({
          url: 'user/search',
          method: 'get',
          params: {
            keyword: query
          }
        }).then(({data}) => {
          this.users = data
        })
      } else {
        this.users = [];
      }
    },
    handleSelect() {
      this.selected = this.users.find(user => user.id === this.form.target)
    },
    handleSave() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          console.log(this.form)
          this.$http.post('user/transfer', JSON.stringify(this.form)).then(({data}) => {
            if (data && data.code === 200) {
              this.$message({
                message: '操作成功',
                type: 'success',
                duration: 1500,
                onClose: () => {
                  this.$emit('refresh')
                  this.close()
                }
              })
            } else {
              this.$message.error(data.msg)
            }
          })
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
.box-card {
  width: 300px;

  .wrapper {
    display: flex;
    line-height: 25px;

    .block {
      margin-right: 15px;
    }
  }
}
</style>
